import type { Component, InjectionKey } from "vue";
import { inject, provide, shallowReactive } from "vue";

import type { ButtonState } from "@/components/base/BaseButton.vue";
import type { Tint } from "@/components/base/types";
import type { ExportRoot } from "@/components/marketplace/export";

export type SettingsTopbarMoreAction = {
  text: string;
  icon?: Component;
  tint?: Tint;
  shortcutsDisplay?: string;
  onClick: () => void;
};

export type SettingsTopbarActions = {
  saveState: ButtonState | null;
  runState: ButtonState | null;
  onSave: (() => void) | null;
  onRun: (() => void) | null;
  shareRoot: ExportRoot | null;
  shareOrganizationId: string | undefined;
  moreActions: SettingsTopbarMoreAction[];
};

const SETTINGS_TOPBAR_ACTIONS_KEY: InjectionKey<SettingsTopbarActions> = Symbol(
  "settingsTopbarActions"
);

export function provideSettingsTopbarActions(): SettingsTopbarActions {
  // Every field is replaced as a whole. Keeping nested values shallow also
  // prevents component-valued icons in moreActions from becoming proxies.
  const actions = shallowReactive<SettingsTopbarActions>({
    saveState: null,
    runState: null,
    onSave: null,
    onRun: null,
    shareRoot: null,
    shareOrganizationId: undefined,
    moreActions: [],
  });
  provide(SETTINGS_TOPBAR_ACTIONS_KEY, actions);
  return actions;
}

export function injectSettingsTopbarActions(): SettingsTopbarActions | null {
  return inject(SETTINGS_TOPBAR_ACTIONS_KEY, null);
}
